module.exports = __webpack_public_path__ + "static/media/notfound.ddded74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/POISearch/images/notfound.png
// module id = 577
// module chunks = 0